'use client';
import useNavigate from '@/hooks/useNavigate';
import Button from '@/components/Button';

import { motion, AnimatePresence } from 'motion/react';
import { forgotPasswordEmailSend, sendEmailChangePasswordByEmail } from '@/services/register';
import { useState, useContext } from 'react';
import ConfirmAccount from './account/ConfirmAccount';
import { BootstrapContext } from '@/pagesComponents/Layout';

const ResetPasswordForm = () => {
  const [errorState, setErrorState] = useState(false);
  const [errorMessage, setErrorMessage] = useState('There was a peroblem');
  const [slideDisplay, setSlideDisplay] = useState(1);
  const [account, setAccount] = useState({ email: null });
  const navigate = useNavigate();
  const bootstrap = useContext(BootstrapContext);
  const sendSmsCode = (data) => {
    if (typeof window !== 'undefined') {
      const modal = document.getElementById('login-modal');
      const modalInstance = bootstrap.Modal.getInstance(modal);
      modalInstance.hide();
      const openNavbar = document.getElementById('navbarSupportedContent');
      openNavbar.classList.remove('show');

      const fiveDigitCodeString = data.code.toString().padStart(5, '0');
      const encodedEmail = encodeURIComponent(account.email);
      navigate(`/reset-password?email=${encodedEmail}&phoneCode=${fiveDigitCodeString}`);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = e.target;
      const formData = new FormData(form);
      const dataToSend = Object.fromEntries(formData.entries());
      setAccount(dataToSend);

      const response = await forgotPasswordEmailSend(dataToSend.email);

      if (response === 'OK') {
        setErrorState(false);
        setErrorMessage('');
        setSlideDisplay(2);
      } else {
        setErrorState(true);
        setErrorMessage('Une erreur est survenue');
      }
    } catch (e) {
      const messageHtml = '<p>' + e.message + '</p>';
      setErrorState(true);
      setErrorMessage(messageHtml);
    } finally {
      setTimeout(() => {
        setErrorState(false);
        setErrorMessage('');
      }, 5000);
    }
  };

  return (
    <AnimatePresence>
      {slideDisplay === 1 && (
        <motion.form
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          onSubmit={handleSubmit}
        >
          {errorState && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              className="alert alert-danger"
              role="alert"
              dangerouslySetInnerHTML={{ __html: errorMessage }}
            />
          )}
          <div className="form-group mb-2">
            <label className={'form-label'} htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              className="form-control"
              name={'email'}
              placeholder="Email"
              required
            />
          </div>
          <div className="form-group d-flex justify-content-end">
            <Button type="submit" className="btn btn-primary btn-submit">
              Soumettre
            </Button>
          </div>
        </motion.form>
      )}
      {slideDisplay === 2 && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
        >
          <ConfirmAccount
            account={account}
            confirmByEmail={sendEmailChangePasswordByEmail}
            sendSMSCode={sendSmsCode}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ResetPasswordForm;
